import { useTranslation } from 'react-i18next';
import type { WhatsAppMessage } from './whatsAppMessageTypes';

/**
 * WHATSAPP DELIVERY STATUS — segnala nella bolla i messaggi in uscita che Meta NON
 * ha consegnato.
 *
 * Volutamente asimmetrico: la progressione della consegna (preso in carico, inviato,
 * consegnato, letto) NON si mostra, perché è rumore su ogni singola bolla. Il
 * fallimento sì, perché è l'unica cosa che l'utente deve sapere e non può dedurre:
 * la Graph API risponde 200 appena prende in carico il messaggio e l'esito vero
 * arriva dopo, dal webhook — senza questo marcatore un messaggio rifiutato da Meta
 * sarebbe indistinguibile da uno consegnato.
 *
 * Lo stato completo resta comunque in `WhatsAppMessage.status` e nell'API: se un
 * giorno servissero le spunte, il dato c'è già.
 */
interface WhatsAppDeliveryStatusProps {
  message: WhatsAppMessage;
}

export function WhatsAppDeliveryStatus({
  message,
}: WhatsAppDeliveryStatusProps) {
  const { t } = useTranslation();

  if (message.direction !== 'OUT' || message.status !== 'FAILED') return null;

  const label = message.errorMessage || t('whatsapp.status.FAILED');

  return (
    <span className="wa-status wa-status--failed" title={label} aria-label={label}>
      ✕
    </span>
  );
}

export default WhatsAppDeliveryStatus;
